import React from 'react';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  contentNormalPadding: {
    padding: `${theme.spacing(4)}px ${theme.spacing(6)}px`
  },
  contentNoPadding: {
    padding: 0
  }
}));

const TabContentContainer = ({
  TabContent,
  language,
  tabContentPadding = 'normal'
}) => {
  const classes = useStyles();
  const containerClasses = cx({
    [classes.contentNormalPadding]: tabContentPadding === 'normal',
    [classes.contentNoPadding]: tabContentPadding === 'none'
  });
  return (
    <div className={containerClasses} data-testid="form-tab-content">
      <TabContent language={language} />
    </div>
  );
};

export default TabContentContainer;
